var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_vm._v(" Refait avec amour le Tusmo de "),_c('a',{attrs:{"href":"https://x.com/Neurosis_44","target":"_blank"}},[_vm._v("Neurosis_44")]),_vm._v(" ♡ ")])
}]

export { render, staticRenderFns }